module.exports = __webpack_public_path__ + "img/1.0646d004.svg";